// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"EmailSignUp__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/EmailSignUp/EmailSignUp.scss
 ** module id = 916
 ** module chunks = 1
 **/